import React from 'react'
import { dialogTypes } from '@/dialogs'
import { LookupCell, Column, DateCell, DateFilterCell } from '@/components/BsrsGrid'
import { PropertyRenderer } from '@/components/changeRequests'
import { useLocalization } from '@/hooks/localization'
import { PermissionSectionProvider } from '../changeRequests/institutionPermissionProvider'
import { institutionPermissionTypes } from '@/enums/institutionPermissionTypes'

export const BranchManagers = React.memo(function BranchManagers ({ dataSource, readonly, branchId }) {
  const { localize } = useLocalization()
  return (
    <PermissionSectionProvider institutionPermission={institutionPermissionTypes.enum.Branches}>
      <PropertyRenderer name='relatedPersons' inputType='grid' dataSource={dataSource} readonly={readonly}
        addButtonLabel='Institutions.AddBranchManager'
        detailDialog={{ dialogType: dialogTypes.branchManagers, branchId: branchId }}>
        <Column field='person' title={localize('Common.Name')} cell={LookupCell} width='200px' />
        <Column field='validFrom' title={localize('Common.ValidFrom')} filter='date' cell={DateCell} filterCell={DateFilterCell} width='200px' />
        <Column field='validTo' title={localize('Common.ValidTo')} filter='date' cell={DateCell} filterCell={DateFilterCell} width='200px' />
      </PropertyRenderer>
    </PermissionSectionProvider>
  )
})



// WEBPACK FOOTER //
// ./src/components/demographics/branchManagers.js